export const SET_DEFAULT_PAGE_LIMIT = "SET_DEFAULT_PAGE_LIMIT";

export const SET_LOAD = "SET_LOAD";
